import { required } from 'services/validators'

export default values => {
  const errors = {}
  if (!required(values.title)) {
    errors.title = 'Título requerido'
  }
  if (!required(values.content)) {
    errors.content = 'Contenido requerido'
  }
  return errors
}

